import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const yardinspection = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/yard/{profile}/yard-inspection',
    app: 'yard'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'yard', model: 'yardinspection' }
    ),
    { }
  )
)()

export { yardinspection, TYPES }
